<template>
  <div>
    <b-list-group>
      <!-- <span style="padding-bottom:80px"></span> -->
      
        <b-button  @click="visible = !visible" variant="outline-primary" class="m-1 ">Manage Users   
             <b-icon class="ml-2" v-if="visible"  icon="chevron-bar-up" aria-hidden="true"></b-icon>
              <b-icon class="ml-2" v-else  icon="chevron-bar-down" aria-hidden="true"></b-icon>
        </b-button>

         
     
      <b-collapse visible v-model="visible">
        <b-list-group-item to="/" >User Management</b-list-group-item>
        <b-list-group-item to="/admin/roleManagement">User Role Management</b-list-group-item>
         <b-list-group-item to="/admin/roleAssign">Role Management</b-list-group-item>
      </b-collapse>
    </b-list-group>
  </div>
</template>

<script>
export default {
  name: "'Sidebar",
  data() {
    return {
      visible: true
    };
  }
};
</script>

<style>
</style>